import { useEffect, useState } from "react";
import {
  fetchContacts,
  deleteContact
} from "../../services/adminService";
import Pagination from "../../components/Pagination";

function Contacts() {
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    try {
      setLoading(true);
      const res = await fetchContacts(page);
      setList(res.data.data || []);
      setPages(res.data.pages || 1);
    } catch (err) {
      console.error("Error loading contacts", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [page]);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this message?")) return;
    await deleteContact(id);
    loadData();
  };

  return (
    <div>
      <h2>Contacts</h2>

      {/* LOADING */}
      {loading && (
        <div className="loading-message">
          <span className="loading-spinner" />
          Loading...
        </div>
      )}

      {/* LIST */}
      <div className="admin-grid">
        {!loading && list.length === 0 ? (
          <div className="empty-state">
            <h3>No messages yet</h3>
            <p>Contact messages will appear here.</p>
          </div>
        ) : (
          list.map((c) => (
            <div key={c._id} className="admin-card contact-card">
              <h4>{c.name}</h4>
              <p><b>Email:</b> {c.email}</p>
              <p className="message">{c.message}</p>

              <small className="time">
                {new Date(c.createdAt).toLocaleString()}
              </small>

              {/* 📧 Gmail Reply */}
                <a
                  href={`https://mail.google.com/mail/?view=cm&fs=1&to=${c.email}&su=Reply from BusinessNearMe&body=Hi ${c.name},`}
                  target="_blank"
                  rel="noreferrer"
                  className="reply gmail"
              >
                Gmail
              </a>

              {/* ACTION */}
              <div className="admin-actions">
                <button
                  className="delete"
                  onClick={() => handleDelete(c._id)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      {/* ✅ PAGINATION (REUSABLE) */}
      <div className="admin-pagination-wrapper">
        <Pagination
          currentPage={page}
          totalPages={pages}
          onPageChange={(p) => setPage(p)}
        />
      </div>
    </div>
  );
}

export default Contacts;